import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import { useState, useRef } from "react";
import { I18nLegacy } from "@silvertours/front-legacy-shared";
import { Ui } from "@silvertours/front-shared";
import { useSearchSuggestions, getLocation, Runtime } from "@silvertours/front-entities";
import { LocationSuggest } from "../LocationSuggest";
import { SearchHistory } from "../SearchHistory/SearchHistory";
import { Container } from "./SearchInput.styles";
import { useSearchContext } from "../context";
var isDeparture = function(props) {
    return props.direction === "departure";
};
var getSubmit = function(props) {
    return isDeparture(props) ? props.onServiceNumbersSubmit : undefined;
};
var SearchInput = function(props) {
    var ref = useSearchContext(), getInputValue = ref.getInputValue, isInternalCall = ref.isInternalCall, state = ref.state, setInputValue = ref.setInputValue, makeSetLocation = ref.makeSetLocation, setError = ref.setError;
    var direction = props.direction, _history = props.history, history = _history === void 0 ? {
        items: []
    } : _history, icon = props.icon, label = props.label, placeholder = props.placeholder, id = props.id, name = props.name;
    var handleSubmit = getSubmit(props);
    var setLocation = makeSetLocation(direction);
    var value = getInputValue(direction);
    var shouldSearchServiceNumbers = isInternalCall && direction === "departure" && value[0] === "#";
    var ref1 = useState(false), showSearchHistory = ref1[0], setShowSearchHistory = ref1[1];
    var ref2 = useState(false), showLocationSuggest = ref2[0], setShowLocationSuggest = ref2[1];
    var fieldRef = useRef(null);
    var ref3 = I18nLegacy.useLocale(), language = ref3.language, market = ref3.market;
    var consumerApiSettings = Runtime.useConsumerApi().consumerApiSettings;
    var ref4 = useSearchSuggestions(language, market, consumerApiSettings), clearResults = ref4.clearResults, fetchSuggestions = ref4.fetchSuggestions, loading = ref4.loading, results = ref4.results;
    var handleChange = function(inputValue) {
        setInputValue(direction, inputValue);
        if (inputValue === "") {
            clearResults();
            setShowSearchHistory(true);
            setShowLocationSuggest(false);
        } else {
            setShowSearchHistory(false);
            if (shouldSearchServiceNumbers) {
                setShowLocationSuggest(false);
            } else {
                setShowLocationSuggest(true);
                setLocation(null);
                fetchSuggestions(inputValue);
            }
        }
    };
    var handleSuggestionValue = function(suggestion) {
        if (suggestion) {
            var location = getLocation(suggestion);
            setShowLocationSuggest(false);
            setInputValue(direction, location.name);
            setLocation(location);
            clearResults();
        } else {
            handleChange(value);
            if (shouldSearchServiceNumbers && !!handleSubmit) {
                handleSubmit();
            }
        }
    };
    if (!state) {
        return null;
    }
    return /*#__PURE__*/ _jsxs(Container, {
        role: "combobox",
        "aria-expanded": showSearchHistory,
        children: [
            /*#__PURE__*/ _jsx(Ui.Input, {
                ref: fieldRef,
                value: value,
                label: label,
                name: name !== null && name !== void 0 ? name : id,
                id: id,
                placeholder: placeholder,
                icon: icon,
                error: state.locationError,
                autoComplete: "off",
                forcedLabel: true,
                onFocus: function(e) {
                    setError({
                        kind: "locationError",
                        message: ""
                    });
                    if (e.target.value === "") {
                        setShowSearchHistory(true);
                    } else {
                        fetchSuggestions(e.target.value);
                        setShowLocationSuggest(true);
                    }
                },
                onBlur: function(e) {
                    var ref, ref1, ref2;
                    if (!((ref = e.relatedTarget) === null || ref === void 0 ? void 0 : ref.className.includes("searchHistory"))) {
                        setShowSearchHistory(false);
                    }
                    if (!(((ref1 = e.relatedTarget) === null || ref1 === void 0 ? void 0 : ref1.className.includes("inputCloseIcon")) || ((ref2 = e.relatedTarget) === null || ref2 === void 0 ? void 0 : ref2.id.includes("locationSuggest")))) {
                        setShowLocationSuggest(false);
                    }
                },
                onChange: function(event) {
                    return handleChange(event.target.value);
                }
            }),
            history.items.length > 0 && showSearchHistory && /*#__PURE__*/ _jsx(SearchHistory, {
                items: history.items,
                onItemClick: clearResults,
                onLastElementBlur: function() {
                    setShowSearchHistory(false);
                }
            }),
            showLocationSuggest && /*#__PURE__*/ _jsx(LocationSuggest, {
                connectedInputContainer: fieldRef,
                loading: loading,
                onLastElementBlur: function() {
                    setShowLocationSuggest(false);
                },
                onItemClick: handleSuggestionValue,
                results: results
            })
        ]
    });
};
export { SearchInput };
